import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import { OTP, Typography, LineProgressBar } from 'mobily-ui-library/lib';

import { cstCancelFiberInstallationByCustomer, resendOtp, submitODBCancelOTP } from '../../api/api';

import BackArrow from '../../assets/BackArrow.svg';
import './CancellationOTP.scss';

const win: any = window;

function CancellationOTP() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, smsSentTo, refId, cancellationFormData, requestDetails } = state;
    const { t } = useTranslation();

    const [timer, setTimer] = useState(120);
    const [attempt, setAttempt] = useState(0);
    const [otpValue, setotpValue] = useState('');
    const [OTPError, setOTPError] = useState('');

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [])

    useEffect(() => {
        let countdown: any;
        const countdownFunction = () => {
            countdown = setInterval(() => {
                setTimer(prevTimer => {
                    if (prevTimer > 0) {
                        return prevTimer - 1;
                    } else {
                        clearInterval(countdown);
                        return 0;
                    }
                });
            }, 1000);
        }
        countdownFunction();

        return () => clearInterval(countdown);
    }, [timer]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleOTPChange = (otp: any) => {
        setotpValue(otp);

        if (otp.length === 4) {
            dispatch({ type: "SET_LOADER", payload: true });
            validateOTPAPI(otp);
        }
    }

    const validateOTPAPI = (otp: any) => {
        setOTPError('')

        submitODBCancelOTP(otp, refId)
            .then(async (res: any) => {
                if (res?.status === 204) {
                    setotpValue("");
                    CancelFiberInstallationRequestByCustomer()
                } else if (res.status === 260) {
                    const sourceCode = res?.data?.status?.sourceCode;
                    dispatch({ type: "SET_LOADER", payload: false });
                    if (sourceCode === 'MAPI-260-2') {
                        setOTPError(t(`The_code_you_entered_is_incorrect`));
                    } else if (sourceCode === 'MAPI-260-3') {
                        setOTPError(t('This_code_has_now_expired'));
                    } else if (sourceCode === 'MAPI-260-4') {
                        setOTPError(t('You_exceeded_the_maximum_amount_of_OTP_entries'));
                    } else {
                        window.location.href = win['base_portal_url'] + win['errorPageURL'];
                    }
                } else {
                    window.location.href = win['base_portal_url'] + win['errorPageURL'];
                }
            }).catch(() => {
                dispatch({ type: "SET_LOADER", payload: false });
                window.location.href = win['base_portal_url'] + win['errorPageURL'];
            })
    }

    const CancelFiberInstallationRequestByCustomer = async () => {
        try {
            dispatch({ type: "SET_LOADER", payload: true });
            const data = {
                "requestNumber": requestDetails?.CSTRequestNumber,
                "cancelReasonId": cancellationFormData?.reason,
                "cancelReasonText": cancellationFormData?.reasonText,
                "additionalData": {
                    "MobilyOrderNumber": requestDetails?.MobilyOrderNumber,
                    "SAN": requestDetails?.SAN,
                    "MobileNumber": requestDetails?.MobileNumber,
                    "CustomerID": requestDetails?.NationalId,
                    "EmailAddress": requestDetails?.EmailAddress
                }
            }
            const res = await cstCancelFiberInstallationByCustomer(data)
            dispatch({ type: 'UPDATE_PAGE', payload: 'successPage' });
            dispatch({ type: 'UPDATE_SUCCESS_TYPE', payload: 'cancel' })
            dispatch({ type: "SET_LOADER", payload: false });
        } catch (err) {
            dispatch({ type: "SET_LOADER", payload: false });
            window.location.href = win['base_portal_url'] + win['errorPageURL'];
        }
    }

    const handleResend = () => {
        setTimer(120);
        setOTPError('');
        setAttempt(prev => prev + 1);
        dispatch({ type: "SET_LOADER", payload: true });
        const data = {
            "operation": "RESEND_OTP",
            "extraInfo": [
                {
                    "key": "REF_ID",
                    "value": refId
                }
            ]
        }

        resendOtp(data)
            .then((res: any) => {
                dispatch({ type: "SET_LOADER", payload: false });
                if (res.status === 204) {
                    setotpValue("");
                } else if (res.status === 260) {
                    const sourceCode = res?.data?.status?.sourceCode;
                    dispatch({ type: "SET_LOADER", payload: false });
                    if (sourceCode === 'MAPI-260-1') {
                        setOTPError(t(`You_exceeded_the_maximum_amount_of_requests`));
                    } else {
                        window.location.href = win['base_portal_url'] + win['errorPageURL'];
                    }
                } else {
                    window.location.href = win['base_portal_url'] + win['errorPageURL'];
                }
            }).catch(err => {
                window.location.href = win['base_portal_url'] + win['errorPageURL'];
            });
    }

    const handleBackArrow = () => {
        dispatch({ type: 'UPDATE_PAGE', payload: 'requestList' });
    }

    return (
        <div className='FTTH__OTPContainer'>
            <div className='d-flex flex-column'>
                <div className='d-flex justify-content-between w-full align-items-center px-2'>
                    <img
                        src={BackArrow}
                        alt='back-arrow'
                        className={rtl ? 'DSHN__backArrow DSHN_right' : 'DSHN__backArrow'}
                        onClick={handleBackArrow}
                        style={{ visibility: "visible" }}
                    />
                    <Typography rtl={rtl} className='FTTH__HeaderText'>{t('Cancel_FTTH_Coverage_request')}</Typography>
                    <a href="/wps/portal/web/personal/am-overview/contact-us">
                        <Typography rtl={rtl} color='#008CFF' fontFamily='SimplonNorm-Bold, ExpoArabic-Bold'>{t("HELP")}</Typography>
                    </a>
                </div>
                <div className='d-flex mt-1 justify-content-center'>
                    <div className='w-24'></div>
                    <div className='w-200 justify-self-center'><LineProgressBar rtl={rtl} percent={75} /></div>
                    <div></div>
                </div>
            </div>

            <div className='SL__headerText'>
                <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Confirm_its_you')}</Typography>
                <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                    {t('We_sent_a_one-time_code_to')}
                    <div className='Verify__Msisdn'>{smsSentTo}.</div>
                    <div>{t('Please_enter_it_below_to_continue')}</div>
                </Typography>
                <div className='Verify__OTP'>
                    <OTP id="otp-input" rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                    {OTPError && (
                        <Typography className='Verify__otpError' rtl={rtl}>
                            {OTPError}
                        </Typography>)}
                    {attempt < 4 && (timer > 0 ? (
                        <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                            {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                        </Typography>
                    ) : (
                        <Typography className='Verify__Resend' rtl={rtl}>
                            {t("Didnt_receive_the_code")}
                            <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                                {t("Send_again")}
                            </span>
                        </Typography>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CancellationOTP